<template>
  <div class="contractAdd">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-title">承租信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">承租主体：</span>
          </div>
          <el-select v-model="formData.leaseCode" filterable remote reserve-keyword placeholder="请输入关键词" size="mini" style="width: 220px" :remote-method="leaseRemoteMethod" @change="changeLeaseCode">
            <el-option v-for="item in leaseList" :key="item.code" :label="item._label" :value="item.code"></el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">签订人：</span>
          </div>
          <el-input v-model="formData.signerName" size="mini" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">签订人手机：</span>
          </div>
          <el-input v-model="formData.signerPhone" size="mini" style="width: 220px" />
        </div>
<!--        <div>-->
<!--          <div class="textBox">-->
<!--            <span class="line-text">统一社会信用代码：</span>-->
<!--          </div>-->
<!--          <el-input v-model="formData.enterpriseUnifyCode" size="mini" style="width: 220px" disabled />-->
<!--        </div>-->
<!--        <div>-->
<!--          <div class="textBox">-->
<!--            <span class="line-text">法人姓名：</span>-->
<!--          </div>-->
<!--          <el-input v-model="formData.legalPersonName" size="mini" style="width: 220px" disabled />-->
<!--        </div>-->
      </div>
<!--      <div class="form-line">-->
<!--        <div>-->
<!--          <div class="textBox">-->
<!--            <span class="line-text">行业分类：</span>-->
<!--          </div>-->
<!--          <el-input v-model="formData.industry" size="mini" style="width: 220px" disabled />-->
<!--        </div>-->

<!--      </div>-->
<!--      <div class="form-line">-->
<!--        <div>-->
<!--          <div class="textBox">-->
<!--            <span class="line-text">通讯地址：</span>-->
<!--          </div>-->
<!--          <el-input v-model="formData.address" size="mini" style="width: 220px" disabled />-->
<!--        </div>-->
<!--      </div>-->

      <div class="form-title">房源信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间号：</span>
          </div>
          <el-select v-model="roomChooseData.roomChooseCodes" multiple collapse-tags filterable placeholder="请输入关键词" size="mini" style="width: 440px" @change="changeRoomChoose">
            <el-option v-for="item in roomChooseData.roomList" :key="item.code" :label="item._label" :value="item.code"></el-option>
          </el-select>
        </div>
        <div v-if="formData.rentType == 1">
          <div class="textBox">
            <span class="line-text">床位：</span>
          </div>
          <el-select v-model="roomChooseData.bedChooseCodes" multiple placeholder="请选择床位" size="mini" style="width: 220px" @change="changeBedsChoose">
            <el-option v-for="item in roomChooseData.bedsList" :key="item.code" :label="item.bedsNumber" :value="item.code"></el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">租赁面积：</span>
          </div>
          <el-input v-model="leaseArea" size="mini" style="width: 220px" disabled>
            <template slot="append">m²</template>
          </el-input>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">房屋用途：</span>
          </div>
          <el-input v-model="roomUsage" size="mini" style="width: 220px" />
        </div>
      </div>
      <div class="form-line">        
        <div>
          <div class="textBox">
            <span class="line-text">房间单价：</span>
          </div>
          <el-input v-model="roomUnitPrice" size="mini" style="width: 220px" disabled>
            <template slot="append">元/月</template>
          </el-input>
        </div>
      </div>

      <div class="form-title">合同信息</div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同编号：</span>
          </div>
          <el-input
            v-model="formData.code"
            size="mini"
            style="width: 220px"
          />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同开始时间：</span>
          </div>
          <el-date-picker v-model="formData.contractStartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="mini" @change="changeContractStartDate()"></el-date-picker>
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同结束时间：</span>
          </div>
          <el-date-picker v-model="formData.contractEndDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="mini" @change="changeContractEndDate()"></el-date-picker>
        </div>
      </div>
      <div class="form-line discount-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同签订时间：</span>
          </div>
          <el-date-picker v-model="formData.contractSignDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="mini"></el-date-picker>
        </div>
      </div>
      <el-tabs type="border-card" style="box-shadow: none;margin-top: 10px;width: 100%;">
        <el-tab-pane label="租金条款">
          <div style="height: 300px;overflow-y: auto;">
            <div class="form-title" style="border-left: 3px solid #ffffff;display: flex;justify-content: space-between;">
              <span>保证金信息</span>
            </div>
            <div class="form-line" style="flex-wrap: wrap">
              <div>
                <div class="textBox">
                  <span class="line-text">押金期数：</span>
                </div>
                <el-select v-model="leaseDepositPeriod" placeholder="请选择" size="mini" clearable style="width: 220px">
                  <el-option
                    v-for="item in leaseDepositPeriodList"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
              <div v-if="leaseDepositPeriod === '4'" style="margin-bottom: 10px;">
                <div class="textBox">
                  <span class="line-text">自定义押金期数：</span>
                </div>
                <el-input-number v-model="leaseDepositPeriodCount" controls-position="right" :min="4" :max="24" size="mini" type="number" style="width: 220px;vertical-align: top;" />
              </div>
              <div>
                <div class="textBox">
                  <span class="line-text">保证金金额：</span>
                </div>
                <el-input v-model="formData.leasePledge" size="mini" type="number" style="width: 220px;vertical-align: top;" v-on:blur="leasePledgeChange()">
                  <template slot="append">元</template>
                </el-input>
              </div>
              <div>
                <div class="textBox">
                  <span class="line-text">币种：</span>
                </div>
                <el-select v-model="currency" placeholder="请选择" size="mini" style="width: 220px">
                  <el-option
                    v-for="item in currencyList"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="form-title" style="border-left: 3px solid #ffffff;">
              <span>租金信息</span>
              <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addContractManagerLeaseItem()"></i>
            </div>
            <div v-for="(contractManagerLeaseItem, index) in contractManagerLeaseItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
              <i class="el-icon-close" style="line-height: 24px;font-size: 18px;color: #cccccc;cursor: pointer;position: absolute; right: 3px; top: 1px;" @click="removeContractManagerLeaseItem(index)" v-if="index > 0"></i>
              <div class="form-line discount-line">
                <div>
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">开始时间：</span>
                  </div>
                  <el-date-picker v-model="contractManagerLeaseItem.leaseContractStartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="mini" :picker-options="pickerOptions1" @change="dateDifference"></el-date-picker>
                </div>
                <div>
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">结束时间：</span>
                  </div>
                  <el-date-picker v-model="contractManagerLeaseItem.leaseContractEndDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="mini" :picker-options="pickerOptions2" @change="dateDifference"></el-date-picker>
                </div>
                <div style="display: flex;justify-content: flex-start">
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">合同单价：</span>
                  </div>
                  <el-input v-model="contractManagerLeaseItem.leaseContractPer" type="number" size="mini" style="width: 220px;" v-on:blur="changeLeaseContractPer(index)">
                    <el-select v-model="contractManagerLeaseItem.leaseContractPerUnit" @change="calculationBond" slot="append">
                      <el-option label="元 / 间 / 月" value="1" v-if="formData.rentType == 0" />
                      <el-option label="元 / 间 / 天" value="2" v-if="formData.rentType == 0" />
                      <el-option label="元 / 床 / 月" value="3" v-if="formData.rentType == 1" />
                      <el-option label="元 / 床 / 天" value="4" v-if="formData.rentType == 1" />
                    </el-select>
                  </el-input>
                </div>
              </div>
              <div class="form-line discount-line">
                <div style="display: flex;justify-content: flex-start">
                  <div class="textBox" style="margin-right: 3.9px;">
                    <b class="red">*</b>
                    <span class="line-text">提前付款天数：</span>
                  </div>
                  <el-input v-model="contractManagerLeaseItem.leaseAheadPayDays" type="number" size="mini" style="width: 220px;">
                    <el-select v-model="leaseAheadPayDayType" slot="append">
                      <el-option label="自然日" value="1" />
                    </el-select>
                  </el-input>
                </div>
                <div>
                  <div class="textBox">
                    <span class="line-text">租期划分方式：</span>
                  </div>
                  <el-select v-model="contractManagerLeaseItem.leaseRentDivideType" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option v-for="item in leaseRentDivideTypeList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                  </el-select>
                </div>
                <div>
                  <div class="textBox">
                  <span class="line-text">计费类型
                    <el-tooltip class="item" effect="dark" placement="top-start">
                      <div slot="content">天单价 = 实际输入天单价 或者 按天单价换算方式计算<br/>月单价 = 实际输入月单价 或者 天单价 * 年天数 / 12<br/>按实际天数计费：<br/>总价 = 天单价 * 实际天数 * 租赁数量(面积\工位数)<br/>按月计费：整月按月数计算，不足整月的按实际天数计算<br/>总价 = (月单价 * 月数 + 天单价 * 实际天数) * 租赁数量(面积\工位数)<br/>注意：以上公式在合同单价单位选择(元/天) 或者 (元/月)时，租赁数量以 1 换算</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>：
                  </span>
                  </div>
                  <el-select v-model="contractManagerLeaseItem.leasePayUnitType" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option
                      v-for="item in leasePayUnitTypeList"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-line" style="flex-wrap: wrap">
                <div v-if="contractManagerLeaseItem.leaseContractPerUnit === '2' || contractManagerLeaseItem.leaseContractPerUnit === '4'">
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">天单价换算
                    <el-tooltip class="item" effect="dark" placement="top-end">
                      <div slot="content">
                        <div>按年换算：天单价 = 月单价 * 12 / 年天数</div>
                        <div>按自然月换算：天单价 = 月单价 / 整自然月天数</div>
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>：
                  </span>
                  </div>
                  <el-select v-model="contractManagerLeaseItem.leasePerDayType" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option
                      v-for="item in leasePerDayTypeList"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </div>
                <div v-if="(contractManagerLeaseItem.leaseContractPerUnit === '1' && contractManagerLeaseItem.leasePayUnitType === '2') || (contractManagerLeaseItem.leaseContractPerUnit === '4' && contractManagerLeaseItem.leasePayUnitType === '2') || (contractManagerLeaseItem.leaseContractPerUnit === '2' && contractManagerLeaseItem.leasePerDayType === '2') || (contractManagerLeaseItem.leaseContractPerUnit === '3' && contractManagerLeaseItem.leasePerDayType === '2')">
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">年天数
                    <el-tooltip class="item" effect="dark" placement="top-end">
                      <div slot="content">指一年按多少天来计算</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>：
                  </span>
                  </div>
                  <el-select v-model="contractManagerLeaseItem.daysInYear" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option v-for="item in daysInYearList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                  </el-select>
                </div>
                <div>
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">付款周期
                    <el-tooltip class="item" effect="dark" placement="top-end">
                      <div slot="content">几月一付</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>：
                  </span>
                  </div>
                  <el-select v-model="contractManagerLeaseItem.leasePayPeriod" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option
                      v-for="item in payPeriodList"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <el-collapse v-model="rentActiveNames" style="margin-bottom: 20px;" class="rent-active">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="form-title" style="line-height: 36px;margin-top: 10px;border-left: 3px solid #ffffff;">递增率</div>
                </template>
                <div class="form-line discount-line" v-for="(discount,index) in contractManagerIncreaseLeases" :key="discount.leaseIncreaseTimePoint">
                  <div>
                    <div class="textBox">
                      <span class="line-text">递增时间：</span>
                    </div>
                    <el-select v-model="discount.leaseIncreaseTimePoint" placeholder="请选择" size="mini" style="width: 220px">
                      <el-option
                        v-for="item in incrementalTimePointList"
                        :key="item.code"
                        :label="item.value"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </div>
                  <div style="display: flex;justify-content: flex-start">
                    <div class="textBox">
                      <span class="line-text">单价递增率：</span>
                    </div>
                    <el-input v-model="discount.leaseIncreasePriceRate" type="number" v-on:blur="changeContractManagerIncreaseLeasesPer(index)" size="mini" style="width: 200px;">
                      <el-select v-model="formData.leaseIncreasePriceRateUnitType" slot="append">
                        <el-option label="%" value="1" />
                      </el-select>
                    </el-input>
                  </div>

                  <div style="margin-left: 20px;display: flex;justify-content: flex-start">
                    <i class="el-icon-remove-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;margin-right: 20px;color: #f25721;" @click="removeLeaseLine(index)" v-if="index !== 0"></i>
                    <i class="el-icon-circle-plus-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;color: #00A0E6;" @click="addLeaseLine" v-if="contractManagerIncreaseLeases.length < incrementalTimePointList.length"></i>
                  </div>
                  <!--<div style="display: flex;justify-content: flex-start">-->
                    <!--<div class="textBox">-->
                      <!--<span class="line-text">保证金递增：</span>-->
                    <!--</div>-->
                    <!--<el-input v-model="formData.leaseIncreaseDepositeRate" size="mini" style="width: 200px;">-->
                      <!--<el-select v-model="formData.leaseIncreaseDepositeRateUnitType" slot="append">-->
                        <!--<el-option label="%" value="1" />-->
                        <!--<el-option label="元" value="2" />-->
                      <!--</el-select>-->
                    <!--</el-input>-->
                  <!--</div>-->
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <div class="form-title" style="line-height: 36px;margin-top: 10px;border-left: 3px solid #ffffff;">优惠</div>
                </template>
                <div class="form-line" v-for="(item, index) in contractManagerDiscountLeases" :key="index">
                  <div>
                    <div class="textBox">
                      <span class="line-text">免租起始时间：</span>
                    </div>
                    <el-date-picker v-model="item.startTime" type="date" value-format="yyyy-MM-dd" placeholder="免租起始时间" size="mini" style="width: 200px"></el-date-picker>
                    <!--<el-date-picker-->
                      <!--v-model="item.timeArr"-->
                      <!--type="daterange"-->
                      <!--size="mini"-->
                      <!--unlink-panels-->
                      <!--range-separator="至"-->
                      <!--value-format="yyyy-MM-dd"-->
                      <!--start-placeholder="开始日期"-->
                      <!--end-placeholder="结束日期">-->
                    <!--</el-date-picker>-->
                  </div>
                  <div>
                    <div class="textBox">
                      <span class="line-text">免租结束时间：</span>
                    </div>
                    <el-date-picker v-model="item.endTime" type="date" value-format="yyyy-MM-dd" placeholder="免租结束时间" size="mini" style="width: 200px"></el-date-picker>
                  </div>
                  <div>
                    <div class="textBox">
                      <span class="line-text">备注：</span>
                    </div>
                    <el-input v-model="item.memo" size="mini" style="width: 200px;vertical-align: top;"/>
                  </div>
                  <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addContractManagerDiscountLeases()" v-if="index === contractManagerDiscountLeases.length - 1"></i>
                  <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeContractManagerDiscountLeases(index)" v-if="index > 0"></i>
                </div>
              </el-collapse-item>
            </el-collapse>

            <div class="form-title" style="border-left: 3px solid #ffffff;display: flex;justify-content: space-between;">
              <span></span>
              <button-confirm @confirm="getRentDetail" :value="'点击生成租金明细'" style="display: block;margin-right: 10px;" />
            </div>

            <div v-if="rentDetailData" style="margin-bottom: 20px">
              <div style="display: flex;justify-content: space-between;line-height: 30px;">
                <span style="line-height: 40px;">
                  <span style="color: #7387a3;">保证金应收总计：</span>
                  {{rentTotal2_1}} <span style="color: #7387a3; font-size: 12px;">元;</span>

                  <span style="color: #7387a3;">租金系统计算总额：</span>
                  {{rentTotal1}} <span style="color: #7387a3; font-size: 12px;">元</span>
                  <span style="color: #7387a3;">;租金修改后总额：</span>
                  {{rentTotal2}} <span style="color: #7387a3; font-size: 12px;">元</span>
                </span>
                <span style="padding: 5px 10px;margin-right: 20px;color: #00A0E6;cursor: pointer;" v-if="!changeRentData" @click="changeRentData=true">租金修订</span>
                <div v-if="changeRentData">
                  <span style="display:inline-block;padding: 5px 10px;margin-right: 20px;color: #00A0E6;cursor: pointer;" @click="roundingRent()">一键取整</span>
                  <span style="display:inline-block;padding: 5px 10px;margin-right: 20px;color: #00A0E6;cursor: pointer;" @click="confirmChangeRent()">确定</span>
                  <span style="display:inline-block;padding: 5px 10px;color: #f25721;cursor: pointer;" @click="cancelChangeRent()">取消</span>
                </div>
              </div>

              <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                <div style="width: 300px;">区间</div>
                <div style="width: 100px;">费用类型</div>
                <div style="width: 200px;">付款日</div>
                <div style="width: 150px;">最终单价</div>
                <div style="width: 100px;">系统计算金额</div>
                <div style="width: 100px;">修订金额</div>
              </div>
              <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;">
                租金保证金
              </div>
              <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                <div style="width: 300px;overflow: hidden" :title="rentDetail.deposit.duration">{{rentDetail.deposit.duration}}</div>
                <div style="width: 100px;overflow: hidden" :title="rentDetail.deposit.feeType">{{rentDetail.deposit.feeType}}</div>
                <div style="width: 200px;overflow: hidden" :title="rentDetail.deposit.payDeadline" v-if="!changeRentData">{{rentDetail.deposit.payDeadline}}</div>
                <div style="width: 200px;overflow: hidden" v-if="changeRentData">
                  <el-date-picker v-model="rentDetail.deposit.payDeadline" type="date" value-format="yyyy-MM-dd" placeholder="合同签订日期" size="mini" style="width: 180px;" ></el-date-picker>
                </div>
                <div style="width: 150px;overflow: hidden" title="-">-</div>
                <div style="width: 100px;overflow: hidden" :title="rentDetail.deposit.mustReceive">{{rentDetail.deposit.mustReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                <div style="width: 100px;overflow: hidden" :title="rentDetail.deposit.actualReceive" v-if="!changeRentData">{{rentDetail.deposit.actualReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                <div style="width: 100px;overflow: hidden" v-if="changeRentData">
                  <el-input v-model="rentDetail.deposit.actualReceive" size="mini" type="number"/>
                </div>
              </div>
              <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;">
                租金
              </div>
              <div style="text-align: center;line-height: 36px;">
                <div v-for="item in rentDetail.detailList">
                  <div style="display: flex;justify-content: space-between;">
                    <div style="width: 300px;">{{item.duration}}</div>
                    <div style="width: 100px;">{{item.feeType}}</div>
                    <div style="width: 200px;" v-if="!changeRentData">{{item.payDeadline}}</div>
                    <div style="width: 200px;" v-if="changeRentData">
                      <el-date-picker v-model="item.payDeadline" type="date" value-format="yyyy-MM-dd" placeholder="合同签订日期" size="mini" style="width: 180px;"   ></el-date-picker>
                    </div>
                    <div style="width: 150px;" v-if="!item.children || item.children.length === 0">{{item.contractPer}} <span style="color: #7387a3; font-size: 12px;">{{item.contractPerText}}</span></div>
                    <div style="width: 150px;" v-if="item.children && item.children.length > 0">-</div>
                    <div style="width: 100px;">{{item.mustReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="!changeRentData || (changeRentData && item.children.length > 0)">{{item.actualReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="changeRentData && (!item.children || item.children.length === 0)">
                      <el-input v-model="item.actualReceive" size="mini" style="width: 100px;" />
                    </div>
                  </div>

                  <div style="display: flex;justify-content: space-between;" v-if="item.children" v-for="child in item.children">
                    <div style="width: 300px;text-indent: 2em;"><span style="display: inline-block;width: 10px; height: 9px;vertical-align: text-top;border-bottom: 1px solid #999;margin-right: 5px;"></span>{{child.duration}}</div>
                    <div style="width: 100px;">{{child.feeType}}</div>
                    <div style="width: 200px;">{{child.payDeadline}}</div>
                    <div style="width: 150px;">{{child.contractPer}} <span style="color: #7387a3; font-size: 12px;">{{item.contractPerText}}</span></div>
                    <div style="width: 100px;">{{child.mustReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="!changeRentData">{{child.actualReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="changeRentData">
                      <el-input v-model="child.actualReceive" size="mini" style="width: 100px;" />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物业费条款">
          <div style="height: 300px;overflow-y: auto;">

            <div class="form-title" style="border-left: 3px solid #ffffff;display: flex;justify-content: space-between">
              <span>保证金信息</span>
            </div>
            <div class="form-line">
              <div>
                <div class="textBox">
                  <span class="line-text">保证金金额：</span>
                </div>
                <el-input v-model="formData.propertyPledge" type="number" size="mini" style="width: 220px;vertical-align: top;" v-on:blur="propertyPledgeChange()">
                  <template slot="append">元</template>
                </el-input>
              </div>
              <div>
                <div class="textBox">
                  <span class="line-text">币种：</span>
                </div>
                <el-select v-model="currency" placeholder="请选择" size="mini" style="width: 220px">
                  <el-option
                    v-for="item in currencyList"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="form-title" style="border-left: 3px solid #ffffff;">
              <span>物业费信息</span>
              <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addContractManagerPropertyItem()"></i>
            </div>
            <div v-for="(contractManagerPropertyItem, index) in contractManagerPropertyItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
              <i class="el-icon-close" style="line-height: 24px;font-size: 18px;color: #cccccc;cursor: pointer;position: absolute; right: 3px; top: 1px;" @click="removeContractManagerPropertyItem(index)" v-if="index > 0"></i>
              <div class="form-line discount-line">
                <div>
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">开始时间：</span>
                  </div>
                  <el-date-picker v-model="contractManagerPropertyItem.propertyContractStartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="mini" :picker-options="pickerOptions1" @change="propertyDateDifference"></el-date-picker>
                </div>
                <div>
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">结束时间：</span>
                  </div>
                  <el-date-picker v-model="contractManagerPropertyItem.propertyContractEndDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" size="mini" :picker-options="pickerOptions2" @change="propertyDateDifference"></el-date-picker>
                </div>
                <div style="display: flex;justify-content: flex-start">
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">合同单价：</span>
                  </div>
                  <el-input v-model="contractManagerPropertyItem.propertyContractPer" type="number" size="mini" style="width: 220px;" v-on:blur="changePropertyContractPer(index)">
                    <el-select v-model="contractManagerPropertyItem.propertyContractPerUnit" slot="append">
                      <el-option label="元 / 间 / 月" value="1" v-if="formData.rentType == 0" />
                      <el-option label="元 / 间 / 天" value="2" v-if="formData.rentType == 0" />
                      <el-option label="元 / 床 / 月" value="3" v-if="formData.rentType == 1" />
                      <el-option label="元 / 床 / 天" value="4" v-if="formData.rentType == 1" />
                    </el-select>
                  </el-input>
                </div>
              </div>
              <div class="form-line discount-line">
                <div style="display: flex;justify-content: flex-start">
                  <div class="textBox" style="margin-right: 3.9px;">
                    <b class="red">*</b>
                    <span class="line-text">提前付款天数：</span>
                  </div>
                  <el-input v-model="contractManagerPropertyItem.propertyAheadPayDays" type="number" size="mini" style="width: 220px;">
                    <el-select v-model="leaseAheadPayDayType" slot="append">
                      <el-option label="自然日" value="1" />
                    </el-select>
                  </el-input>
                </div>
                <div>
                  <div class="textBox">
                  <span class="line-text">租期划分方式：</span>
                  </div>
                  <el-select v-model="contractManagerPropertyItem.propertyRentDivideType" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option v-for="item in leaseRentDivideTypeList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                  </el-select>
                </div>
                <div>
                  <div class="textBox">
                  <span class="line-text">计费类型
                    <el-tooltip class="item" effect="dark" placement="top-start">
                      <div slot="content">天单价 = 实际输入天单价 或者 按天单价换算方式计算<br/>月单价 = 实际输入月单价 或者 天单价 * 年天数 / 12<br/>按实际天数计费：<br/>总价 = 天单价 * 实际天数 * 租赁数量(面积\工位数)<br/>按月计费：整月按月数计算，不足整月的按实际天数计算<br/>总价 = (月单价 * 月数 + 天单价 * 实际天数) * 租赁数量(面积\工位数)<br/>注意：以上公式在合同单价单位选择(元/天) 或者 (元/月)时，租赁数量以 1 换算</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>：
                  </span>
                  </div>
                  <el-select v-model="contractManagerPropertyItem.propertyPayUnitType" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option
                      v-for="item in leasePayUnitTypeList"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-line" style="flex-wrap: wrap">
                <div v-if="contractManagerPropertyItem.propertyContractPerUnit === '2' || contractManagerPropertyItem.propertyContractPerUnit === '3'">
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">天单价换算
                    <el-tooltip class="item" effect="dark" placement="top-end">
                      <div slot="content">
                        <div>按年换算：天单价 = 月单价 * 12 / 年天数</div>
                        <div>按自然月换算：天单价 = 月单价 / 整自然月天数</div>
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>：
                  </span>
                  </div>
                  <el-select v-model="contractManagerPropertyItem.propertyPerDayType" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option
                      v-for="item in leasePerDayTypeList"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </div>
                <div v-if="(contractManagerPropertyItem.propertyContractPerUnit === '1' && contractManagerPropertyItem.propertyPayUnitType === '2') || (contractManagerPropertyItem.propertyContractPerUnit === '4' && contractManagerPropertyItem.propertyPayUnitType === '2') || (contractManagerPropertyItem.propertyContractPerUnit === '2' && contractManagerPropertyItem.propertyPerDayType === '2') || (contractManagerPropertyItem.propertyContractPerUnit === '3' && contractManagerPropertyItem.propertyPerDayType === '2')">
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">年天数
                    <el-tooltip class="item" effect="dark" placement="top-end">
                      <div slot="content">指一年按多少天来计算</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>：
                  </span>
                  </div>
                  <el-select v-model="contractManagerPropertyItem.daysInYear" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option v-for="item in daysInYearList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                  </el-select>
                </div>
                <div>
                  <div class="textBox">
                    <b class="red">*</b>
                    <span class="line-text">付款周期
                      <el-tooltip class="item" effect="dark" placement="top-end">
                        <div slot="content">几月一付</div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>：
                    </span>
                  </div>
                  <el-select v-model="contractManagerPropertyItem.propertyPayPeriod" placeholder="请选择" size="mini" style="width: 220px">
                    <el-option v-for="item in payPeriodList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <el-collapse v-model="rentActiveNames" style="margin-bottom: 20px;" class="rent-active">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="form-title" style="line-height: 36px;margin-top: 10px;border-left: 3px solid #ffffff;">递增率</div>
                </template>
                <div class="form-line discount-line" v-for="(discount,index) in contractManagerIncreaseProperties" :key="discount.propertyIncreaseTimePoint">
                  <div>
                    <div class="textBox">
                      <span class="line-text">递增时间：</span>
                    </div>
                    <el-select v-model="discount.propertyIncreaseTimePoint" placeholder="请选择" size="mini" style="width: 220px">
                      <el-option
                        v-for="item in propertyIncrementalTimePointList"
                        :key="item.code"
                        :label="item.value"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </div>
                  <div style="display: flex;justify-content: flex-start">
                    <div class="textBox">
                      <span class="line-text">单价递增率：</span>
                    </div>
                    <el-input v-model="discount.propertyIncreasePriceRate" type="number" size="mini" style="width: 200px;" v-on:blur="changeContractManagerIncreasePropertiesPer(index)">
                      <el-select v-model="formData.propertyIncreasePriceRateUnitType" slot="append">
                        <el-option label="%" value="1" />
                        <!--<el-option label="元" value="2" />-->
                      </el-select>
                    </el-input>
                  </div>

                  <div style="margin-left: 20px;display: flex;justify-content: flex-start">
                    <i class="el-icon-remove-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;margin-right: 20px;color: #f25721;" @click="removePropertyLine(index)" v-if="index !== 0"></i>
                    <i class="el-icon-circle-plus-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;color: #00A0E6;" @click="addPropertyLine" v-if="contractManagerIncreaseProperties.length < propertyIncrementalTimePointList.length"></i>
                  </div>
                  <!--<div style="display: flex;justify-content: flex-start">-->
                    <!--<div class="textBox">-->
                      <!--<span class="line-text">保证金递增：</span>-->
                    <!--</div>-->
                    <!--<el-input v-model="formData.propertyIncreaseDepositeRate" size="mini" style="width: 200px;">-->
                      <!--<el-select v-model="formData.propertyIncreaseDepositeRateUnitType" slot="append">-->
                        <!--<el-option label="%" value="1" />-->
                        <!--<el-option label="元" value="2" />-->
                      <!--</el-select>-->
                    <!--</el-input>-->
                  <!--</div>-->
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <div class="form-title" style="line-height: 36px;margin-top: 10px;border-left: 3px solid #ffffff;">优惠</div>
                </template>
                <div class="form-line" v-for="(item, index) in contractManagerDiscountProperties" :key="index">
                  <div>
                    <div class="textBox">
                      <span class="line-text">免租起始时间：</span>
                    </div>
                    <el-date-picker v-model="item.startTime" type="date" value-format="yyyy-MM-dd" placeholder="免租起始时间" size="mini" style="width: 200px"></el-date-picker>
                    <!--<el-date-picker-->
                      <!--v-model="item.timeArr"-->
                      <!--type="daterange"-->
                      <!--size="mini"-->
                      <!--unlink-panels-->
                      <!--value-format="yyyy-MM-dd"-->
                      <!--range-separator="至"-->
                      <!--start-placeholder="开始日期"-->
                      <!--end-placeholder="结束日期">-->
                    <!--</el-date-picker>-->
                  </div>
                  <div>
                    <div class="textBox">
                      <span class="line-text">免租结束时间：</span>
                    </div>
                    <el-date-picker v-model="item.endTime" type="date" value-format="yyyy-MM-dd" placeholder="免租结束时间" size="mini" style="width: 200px"></el-date-picker>
                  </div>
                  <div>
                    <div class="textBox">
                      <span class="line-text">备注：</span>
                    </div>
                    <el-input v-model="item.memo" size="mini" style="width: 220px;vertical-align: top;"/>
                  </div>
                  <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addContractManagerDiscountProperties()" v-if="index === contractManagerDiscountProperties.length - 1"></i>
                  <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeContractManagerDiscountProperties(index)" v-if="index > 0"></i>
                </div>
              </el-collapse-item>
            </el-collapse>

            <div class="form-title" style="border-left: 3px solid #ffffff;display: flex;justify-content: space-between">
              <span></span>
              <button-confirm @confirm="getPropertyDetail" :value="'点击生成物业明细'" style="display: block;margin-right: 10px;" />
            </div>

            <!--物业明细-->
            <div v-if="propertyDetailData" style="margin-bottom: 20px">
              <div style="display: flex;justify-content: space-between;line-height: 30px;">
                <span style="line-height: 40px;">
                  <span style="color: #7387a3;">保证金应收总计：</span>
                  {{propertyTotal2_1}} <span style="color: #7387a3; font-size: 12px;">元;</span>
                  <span style="color: #7387a3;">物业费系统计算总额：</span>
                  {{propertyTotal1}} <span style="color: #7387a3; font-size: 12px;">元</span>
                  <span style="color: #7387a3;">；物业费修改后总额：</span>
                  {{propertyTotal2}} <span style="color: #7387a3; font-size: 12px;">元</span>
                </span>
                <span style="padding: 5px 10px;margin-right: 20px;color: #00A0E6;cursor: pointer;" v-if="!changePropertyData" @click="changePropertyData=true">物业费修订</span>
                <div v-if="changePropertyData">
                  <span style="display:inline-block;padding: 5px 10px;margin-right: 20px;color: #00A0E6;cursor: pointer;" @click="roundingProperty()">一键取整</span>
                  <span style="display:inline-block;padding: 5px 10px;margin-right: 20px;color: #00A0E6;cursor: pointer;" @click="confirmChangeProperty()">确定</span>
                  <span style="display:inline-block;padding: 5px 10px;color: #f25721;cursor: pointer;" @click="cancelChangeProperty()">取消</span>
                </div>
              </div>

              <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                <div style="width: 300px;">区间</div>
                <div style="width: 100px;">费用类型</div>
                <div style="width: 200px;">付款日</div>
                <div style="width: 150px;">最终单价</div>
                <div style="width: 100px;">系统计算金额</div>
                <div style="width: 100px;">修订金额</div>
              </div>
              <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;">
                物业保证金
              </div>
              <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                <div style="width: 300px;overflow: hidden" :title="propertyDetail.deposit.duration">{{propertyDetail.deposit.duration}}</div>
                <div style="width: 100px;overflow: hidden" :title="propertyDetail.deposit.feeType">{{propertyDetail.deposit.feeType}}</div>
                <div style="width: 200px;overflow: hidden" :title="propertyDetail.deposit.payDeadline" v-if="!changePropertyData">{{propertyDetail.deposit.payDeadline}}</div>
                <div style="width: 200px;overflow: hidden" v-if="changePropertyData">
                  <el-date-picker v-model="propertyDetail.deposit.payDeadline" type="date" value-format="yyyy-MM-dd" placeholder="合同签订日期" size="mini" style="width: 180px;" ></el-date-picker>
                </div>
                <div style="width: 150px;overflow: hidden" title="-">-</div>
                <div style="width: 100px;overflow: hidden" :title="propertyDetail.deposit.mustReceive">{{propertyDetail.deposit.mustReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                <div style="width: 100px;overflow: hidden" :title="propertyDetail.deposit.actualReceive" v-if="!changePropertyData">{{propertyDetail.deposit.actualReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                <div style="width: 100px;overflow: hidden" v-if="changePropertyData">
                  <el-input v-model="propertyDetail.deposit.actualReceive" size="mini" />
                </div>
              </div>
              <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;">
                物业费
              </div>
              <div style="text-align: center;line-height: 36px;">
                <div v-for="item in propertyDetail.detailList">
                  <div style="display: flex;justify-content: space-between;">
                    <div style="width: 300px;">{{item.duration}}</div>
                    <div style="width: 100px;">{{item.feeType}}</div>
                    <div style="width: 200px;" v-if="!changePropertyData">{{item.payDeadline}}</div>
                    <div style="width: 200px;" v-if="changePropertyData">
                      <el-date-picker v-model="item.payDeadline" type="date" value-format="yyyy-MM-dd" placeholder="合同签订日期" size="mini" style="width: 180px;"   ></el-date-picker>
                    </div>
                    <div style="width: 150px;" v-if="!item.children || item.children.length === 0">{{item.contractPer}} <span style="color: #7387a3; font-size: 12px;">{{item.contractPerText}}</span></div>
                    <div style="width: 150px;" v-if="item.children.length > 0">-</div>
                    <div style="width: 100px;">{{item.mustReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="!changePropertyData || (changePropertyData && item.children.length > 0)">{{item.actualReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="changePropertyData && (!item.children || item.children.length === 0)">
                      <el-input v-model="item.actualReceive" size="mini" style="width: 100px;" />
                    </div>
                  </div>

                  <div style="display: flex;justify-content: space-between;" v-if="item.children" v-for="child in item.children">
                    <div style="width: 300px;text-indent: 2em;"><span style="display: inline-block;width: 10px; height: 9px;vertical-align: text-top;border-bottom: 1px solid #999;margin-right: 5px;"></span>{{child.duration}}</div>
                    <div style="width: 100px;">{{child.feeType}}</div>
                    <div style="width: 200px;">{{child.payDeadline}}</div>
                    <div style="width: 150px;">{{child.contractPer}} <span style="color: #7387a3; font-size: 12px;">{{item.contractPerText}}</span></div>
                    <div style="width: 100px;">{{child.mustReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="!changePropertyData">{{child.actualReceive}} <span style="color: #7387a3; font-size: 12px;">元</span></div>
                    <div style="width: 100px;" v-if="changePropertyData">
                      <el-input v-model="child.actualReceive" size="mini" style="width: 100px;" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="其他条款">
          <div style="height: 300px;overflow-y: auto;">
            <div class="form-title" style="border-left: 3px solid #ffffff;display: flex;justify-content: space-between;">
              <span>条款信息</span>
            </div>
            <div class="form-line" v-for="(item, index) in formData.others">
              <div>
                <div class="textBox">
                  <span class="line-text">费用类型：</span>
                </div>
<!--                <el-input v-model="item.otherItemName" size="mini" style="width: 220px" />-->
                <select-with-operation v-model="item.otherItemName" :selectValue="item.billTypeCode" style="width: 220px" :optionList="billTypeList" addTip="添加账单类型" deleteTipInfo="是否确认删除该账单类型？" @addOption="wantAddBillType" @deleteOption="deleteBillType" @changeSelectValue="changeBillType(item,$event)" />
              </div>
              <div>
                <div class="textBox">
                  <span class="line-text">金额：</span>
                </div>
                <el-input v-model="item.otherItemValue" type="number" size="mini" style="width: 220px;vertical-align: top;" v-on:blur="otherItemValueChange(index)">
<!--                  <template slot="append">元</template>-->
                  <el-select v-model="item.otherItemType" slot="append">
                    <el-option label="元 / 次" value="0" />
                    <el-option label="元 / 月" value="1" />
                  </el-select>
                </el-input>
              </div>
              <div v-if="item.otherItemType ==1">
                <div class="textBox">
                  <span class="line-text">缴费周期：</span>
                </div>
                <el-select v-model="item.payPeriod" placeholder="请选择" size="mini" style="width: 220px">
                  <el-option v-for="item in otherItemPayList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                </el-select>
              </div>
              <div>
                <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addOtherItemLine()" v-if="index === formData.others.length - 1"></i>
                <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeOtherItemLine(index)" v-if="index > 0"></i>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div class="form-title">
        附件管理
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">请上传pdf文件</div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-upload ref="uploadContract" :action="uploadAction" :headers="uploadHeaders" :on-success="uploadContractSuccess" :on-error="uploadContractError" :limit="1" style="display: inline-block;margin-left: 10px;" accept=".pdf">
          <span style="color: #00a0e6;cursor: pointer;font-size: 14px">上传</span>
        </el-upload>
      </div>
      <div class="form-line" v-for="(enclosure, enclosureIndex) in formData.attachmentList" v-if="formData.attachmentList.length > 0">
        <div>
          <div class="textBox">
            <span class="line-text">附件{{enclosureIndex + 1}}：</span>
          </div>
          <span style="color: #00a0e6;cursor: pointer;margin-right: 10px;" @click="previewFile(enclosure)">查看</span>
          <span style="color: #f25721;cursor: pointer;margin-right: 10px;" @click="deleteAttachmentItem(enclosureIndex)">删除</span>
        </div>
      </div>
      <div class="form-line" v-if="formData.attachmentList.length === 0">
        <div>
          <div class="textBox">
            <span class="line-text"></span>
          </div>
          <span style="color: #999999;">暂无附件</span>
        </div>
      </div>

      <div class="form-title">其他</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">合同跟进人：</span>
          </div>
          <el-select v-model="formData.fellowPeopleCode" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索" size="mini" style="width: 220px">
            <el-option
              v-for="item in yqPersonList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <!--<b class="red">*</b>-->
            <span class="line-text">客户来源：</span>
          </div>
          <el-select v-model="formData.customSource" placeholder="请选择" size="mini" style="width: 220px">
            <el-option
              v-for="item in customSourceList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <b class="red" v-if="(rentTotal1 !== rentTotal2) || (propertyTotal1 !== propertyTotal2)">*</b>
            <span class="line-text">金额修订说明：</span>
          </div>
          <el-input v-model="formData.memo" size="mini" style="width: 220px;vertical-align: top;" />
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" value="保存" />
        <button-confirm-next @confirm="confirmAndApproval" value="保存 & 审批" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>


    <div class="approveDialogBox">
      <el-dialog title="合同审批" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <!--<div class="approveFlexBox">-->
            <!--<div class="approve_title">-->
              <!--<b class="red">*</b>-->
              <!--<span>审批人</span>-->
            <!--</div>-->
            <!--<el-select v-model="approveAccountCode" placeholder="请选择" size="mini" style="width: 300px">-->
              <!--<el-option-->
                <!--v-for="item in accountList"-->
                <!--:key="item.code"-->
                <!--:label="item._labelName"-->
                <!--:value="item.code">-->
              <!--</el-option>-->
            <!--</el-select>-->
          <!--</div>-->
          <div class="approveFlexBox">
            <div class="approve_title">合同摘要</div>
            <el-input type="textarea" :rows="4" placeholder="请输入合同摘要" v-model="digest" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelApprove">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirmApprove">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="添加账单类型" :visible.sync="addBillTypeVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">类型名称：</span>
          </div>
          <el-input v-model="billTypeName" size="small" style="width: 280px" placeholder="请输入类型名称" />
        </div>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addBillTypeVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addBillType" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/InvestmentLeasing";
import { nError, nSuccess } from "../../../utils/notice";
import { treeApi } from "../../api/TreeApi";
import { bus } from "../../../utils/bus";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import InputTree from "../../../components/common/inputs/input-tree";
import {deepClone} from "../../../utils/toolHandling";
import SelectWithOperation from "../../../components/Select/SelectWithOperation";

export default {
  components: {
    InputTree,
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb,
    SelectWithOperation
  },
  name: "contract-add",
  data() {
    return {
      breadcrumb: [
        {value: "智慧合约", name: "investment-over-view"},
        {value: "合同列表"}
      ],
      accountCode: "",
      accountName: "",
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      mainTitle: "添加合同",
      subheading: "添加签约住户的合同信息",
      isHousingInUnion: false,
      secDiscountOrSecIncreaseRate: "1",
      leaseAheadPayDayType: "1",
      secValue: "",
      trdValue: "",
      leaseList: [],

      yqPersonList: [],

      roomList: [],
      roomChooseData: {
        roomChooseCodes: [],
        roomInfoList: [],
        bedChooseCodes: [],
        bedsList: [],
        roomList: []
      },
      leaseArea: '',      // 租赁面积
      roomUsage: '',      // 房屋用途
      roomUnitPrice: '',  // 房间单价（元/月）
      typeList: [
        {code: '10', name: '公用'},
        {code: '11', name: '自用'},
        {code: '12', name: '出租'}
      ],
      currency: "0",
      currencyList: [
        {code: "0", value: "人民币CNY"}
      ],
      leaseRentDivideTypeList: [
        {code: "1", value: "按起始日划分"}
      ],
      leasePayUnitTypeList: [
        {code: "1", value: "按实际天数计费"},
        {code: "2", value: "按月计费"}
      ],
      leasePerDayTypeList: [
        {code: "1", value: "按自然月换算"},
        {code: "2", value: "按年换算"}
      ],
      daysInYearList: [
        {code: 365, value: 365},
        {code: 366, value: 366}
      ],
      payPeriodList: [
        {code: "1", value: "1月"},
        {code: "3", value: "3月"},
        {code: "6", value: "6月"},
        {code: "12", value: "12月"}
      ],
      otherItemTypeList: [
        {code: "0", value: "一次性"},
        {code: "1", value: "按付款周期"},
      ],
      otherItemPayList: [
        {code: "1", value: "1月"},
        {code: "3", value: "3月"},
        {code: "6", value: "6月"},
        {code: "9", value: "9月"},
        {code: "12", value: "12月"},
        {code: "24", value: "24月"},
        {code: "36", value: "36月"},
      ],
      propertyDiscountTypeList: [
        {code: "1", value: "免租期"}
      ],
      leaseDepositPeriod: "",
      leaseDepositPeriodCount: "",
      leaseDepositPeriodList: [
        {
          code: "1",
          value: "押1"
        },
        {
          code: "2",
          value: "押2"
        },
        {
          code: "3",
          value: "押3"
        },
        {
          code: "4",
          value: "自定义"
        }
      ],
      customSourceList: [
        {code: "自主招商", name: "自主招商"},
        {code: "中介介绍", name: "中介介绍"}
      ],
      incrementalTimePoint: "",
      incrementalTimePointList: [],
      propertyIncrementalTimePointList: [],
      rentDetail: {
        deposit: {},
        detailList: []
      },
      propertyDetail: {
        deposit: {},
        detailList: []
      },
      rentDefaultDetail: {
        deposit: {},
        detailList: []
      },
      propertyDefaultDetail: {
        deposit: {},
        detailList: []
      },
      rentActiveNames: [],
      propertyActiveNames: [],
      rentDetailData: false,
      propertyDetailData: false,
      rentTotal1: 0,
      rentTotal2: 0,
      rentTotal1_1: 0,
      rentTotal2_1: 0,
      changeRentData: false,
      propertyTotal1: 0,
      propertyTotal1_1: 0,
      propertyTotal2: 0,
      propertyTotal2_1: 0,
      changePropertyData: false,

      contractManagerIncreaseLeases: [
        {
          leaseIncreaseTimePoint: "",
          leaseIncreasePriceRate: ""
        }
      ],
      contractManagerIncreaseProperties: [
        {
          propertyIncreaseTimePoint: "",
          propertyIncreasePriceRate: ""
        }
      ],

      // 租金免租期
      contractManagerDiscountLeases: [
        {
          discountType: "1",
          startTime: "",
          endTime: "",
          memo: "",
          timeArr: ""
        }
      ],
      // 物业免租期
      contractManagerDiscountProperties: [
        {
          discountType: "1",
          startTime: "",
          endTime: "",
          memo: "",
          timeArr: ""
        }
      ],
      // 租金分段
      contractManagerLeaseItems: [
        {
          leaseContractStartDate: "", // 租金开始日期
          leaseContractEndDate: "", // 租金结束日期
          leaseContractPer: "", // 合同单价
          leaseContractPerUnit: "1", // 合同单价单位
          leaseAheadPayDays: "", // 提前付款天数
          leaseRentDivideType: "1", // 租期划分方式
          leasePerDayType: "1", // 天单价换算规则
          leasePayUnitType: "2", // 计费类型
          daysInYear: 365, // 年天数
          leasePayPeriod: "1" // 付款周期
        }
      ],
      // 物业费分段
      contractManagerPropertyItems: [
        {
          propertyContractStartDate: "", // 合同开始日期
          propertyContractEndDate: "", // 合同结束日期
          propertyContractPer: "", // 合同单价
          propertyContractPerUnit: "2", // 合同单价单位
          propertyPerDayType: "1", // 天单价换算规则
          propertyAheadPayDays: 15, // 提前付款天数
          propertyRentDivideType: "1", // 租期划分方式
          propertyPayUnitType: "2", // 计费类型
          daysInYear: 365, // 年天数
          propertyPayPeriod: "1" // 付款周期
        }
      ],
      formData: {
        address: "", // 房间地址
        attachmentList: [], // 合约附件
        buildingCode: "", // 楼栋code
        roomInfoCode: "", // 房间code
        roomInfoName: "", // 房间名称
        roomInfoArea: "", // 房源面积
        leaseArea: "", // 租赁面积
        roomUsage: "", // 房屋用途
        roomUnitPrice: "", // 房间单价（元/月）
        officeSeat: "", // 房间工位
        leaseCode: "", // 住户code
        leaseName: "", // 住户名称
        rentType: 0,
        industry: "", // 行业分类
        legalPersonName: "", // 法人姓名
        legalPersonPhone: "", // 法人联系手机
        signerCode: "", // 签订人code
        signerName: "", // 签订人姓名
        signerPhone: "", // 签订人联系手机
        invoiceAddress: "", // 通讯地址

        centStartTime: "", // 住户起始时间
        centEndTime: "", // 住户结束时间

        code: "", //合同编号
        contractStartDate: "", // 合同开始日期
        contractEndDate: "", // 合同结束日期
        contractSignDate: "", // 合同签订日期

        // leaseDepositPeriod: '',
        leasePledge: "0.00", // 租金保证金金额
        contractManagerLeaseItems: [
          {
            leaseContractStartDate: "", // 租金开始日期
            leaseContractEndDate: "", // 租金结束日期
            leaseContractPer: "", // 合同单价
            leaseContractPerUnit: "1", // 合同单价单位
            leaseAheadPayDays: "", // 提前付款天数
            leaseRentDivideType: "1", // 租期划分方式
            leasePerDayType: "1", // 天单价换算规则
            leasePayUnitType: "2", // 计费类型
            daysInYear: 365, // 年天数
            leasePayPeriod: "1" // 付款周期
          }
        ],

        leaseIncreaseTimePoint: "", // 递增时间点
        leaseIncreasePriceRate: "", // 单价递增率
        leaseIncreasePriceRateUnitType: "1", // 单价递增率单位
        leaseIncreaseDepositeRate: "", // 保证金递增率
        leaseIncreaseDepositeRateUnitType: "1", // 保证金递增率单位

        leaseDiscountType: "1", // 优惠类型
        leaseDiscountStartTime: "", // 折扣起始时间
        leaseDiscountEndTime: "", // 折扣结束时间
        leaseDiscountMemo: "", // 折扣备注

        contractManagerIncreaseLeases: [],
        contractManagerIncreaseProperties: [],

        propertyPledge: "", // 物业费保证金金额
        contractManagerPropertyItems: [
          {
            propertyContractStartDate: "", // 合同开始日期
            propertyContractEndDate: "", // 合同结束日期
            propertyContractPer: "", // 合同单价
            propertyContractPerUnit: "2", // 合同单价单位
            propertyPerDayType: "1", // 天单价换算规则
            propertyAheadPayDays: 15, // 提前付款天数
            propertyRentDivideType: "1", // 租期划分方式
            propertyPayUnitType: "2", // 计费类型
            daysInYear: 365, // 年天数
            propertyPayPeriod: "1" // 付款周期
          }
        ],

        propertyIncreaseTimePoint: "", // 递增时间点
        propertyIncreasePriceRate: "", // 单价递增率
        propertyIncreasePriceRateUnitType: "1", // 单价递增率单位
        propertyIncreaseDepositeRate: "", // 保证金递增率
        propertyIncreaseDepositeRateUnitType: "1", // 保证金递增率单位

        propertyDiscountType: "1", // 优惠类型
        propertyDiscountStartTime: "", // 折扣起始时间
        propertyDiscountEndTime: "", // 折扣结束时间
        propertyDiscountMemo: "", // 折扣备注

        others: [
          {
            otherItemName: "",
            otherItemValue: "",
            otherItemType: '0',
            payPeriod: '1'
          }
        ], // 其他费用

        fellowPeopleName: "", // 合同跟进人名称
        fellowPeopleCode: "", // 合同跟进人code
        customSource: "",

        leaseContractManagerDetails: [], // 租金明细
        leaseContractManagerDetail: {}, // 租金保证金
        propertyContractManagerDetails: [], // 物业明细
        propertyContractManagerDetail: {} // 物业保证金
      },
      // 审批信息
      approveDialog: false,
      accountList: [],
      contractCode: "",
      approveAccountCode: "",
      digest: "",

      // 附件信息
      uploadHeaders: {
        token: bus.global.token,
        'yq-app-code': bus.global.yqCode,
      },
      uploadAction: api.uploadPdf,

      billTypeList: [],
      addBillTypeVisible: false,
      billTypeCode: '',
      billTypeName: '',
    };
  },
  created() {
    this.getContractId();
    this.accountCode = bus.global.accountCode;
    this.accountName = bus.global.accountName;
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }

    let oneYearLateYear = year + 1;
    let oneYearLateMonth = month;
    let oneYearLateDate = "";
    if (strDate > 1) {
      oneYearLateDate = strDate - 1;
    } else {
      oneYearLateMonth = month - 1;
      if (oneYearLateMonth < 10) {
        oneYearLateMonth = "0" + oneYearLateMonth;
      }
      if (oneYearLateMonth === 0) {
        oneYearLateMonth = 12;
        oneYearLateYear = year;
      }
      oneYearLateDate = new Date(
        oneYearLateYear,
        oneYearLateMonth,
        0
      ).getDate();
    }
    if (oneYearLateDate >= 0 && oneYearLateDate <= 9) {
      oneYearLateDate = "0" + oneYearLateDate;
    }
    this.formData.contractEndDate = `${oneYearLateYear}-${oneYearLateMonth}-${oneYearLateDate}`;
    this.formData.leaseContractEndDate = `${oneYearLateYear}-${oneYearLateMonth}-${oneYearLateDate}`;
    this.formData.propertyContractEndDate = `${oneYearLateYear}-${oneYearLateMonth}-${oneYearLateDate}`;
    this.formData.leaseContractStartDate = `${year}-${month}-${strDate}`;
    this.formData.contractStartDate = `${year}-${month}-${strDate}`;
    this.formData.contractSignDate = `${year}-${month}-${strDate}`;
    this.formData.propertyContractStartDate = `${year}-${month}-${strDate}`;
    this.leaseRemoteMethod();
    this.remoteMethod();
    // this.getYqPersonList()
    // this.getAccountListByCode()
    this.getOtherBillTypeList();
  },
  mounted() {
    this.changePickerOptions1();
    this.changePickerOptions2();
    this.dateDifference();
    this.propertyDateDifference();
  },
  methods: {
    //获取合同编号
    getContractId(){
      this.$axios.get(api.getContractId).then( res => {
        if(res.data.retCode === 1){
          this.formData.code = res.data.data
        }
      } )
    },
    // 获取账单类型列表
    getOtherBillTypeList () {
      this.$axios.post(api.getOtherBillTypeList, {})
        .then(res => {
          this.billTypeList = res.data.data || []
        })
        .catch(errorHandler("获取账单类型失败"));
    },
    // 选择房间类型
    changeBillType (item,e) {
      console.log(item,e)
      this.billTypeList.forEach(a =>{
        if (a.code === e){
          item.otherItemName = a.name
        }
      })
      this.billTypeCode = e
      item.billTypeCode = e
    },
    // 添加房间类型弹窗
    wantAddBillType () {
      this.billTypeName = ''
      this.addBillTypeVisible = true
    },
    // 添加房间类型
    addBillType () {
      if (!this.billTypeName) {
        nError('请输入类型名称')
      }
      let typeList = []
      typeList.push(this.billTypeName)
      this.$axios.post(api.addOtherBillType, typeList)
        .then(res => {
          this.addBillTypeVisible = false
          nSuccess('添加成功')
          this.getOtherBillTypeList()
        })
        .catch(errorHandler('添加失败'))
    },
    // 删除房间类型
    deleteBillType (option) {
      this.$axios.post(api.deleteOtherBillTypeByCodes, [option.code])
        .then(res => {
          this.roomTypeCode = ''
          nSuccess('删除成功')
          this.getOtherBillTypeList()
        })
        .catch(errorHandler('删除失败'))
    },
    // 获取承租主体列表
    leaseRemoteMethod(query) {
      this.$axios.post(api.getLeaseList, {
        searchKey: query,
      })
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            if (v.enterpriseName) {
              v._label = `${v.enterpriseName}/${v.personName}/${v.phone}`
            } else {
              v._label = `${v.personName}/${v.phone}`
            }
          })
          this.leaseList = data;
        })
        .catch(errorHandler("获取承租主体列表失败"));
    },

    // 承租主体变更
    changeLeaseCode (value) {
      this.leaseList.map(v => {
        if (v.code === value) {
          this.formData.mainType = v.mainType;
          this.formData.leaseCode = v.code;
          this.formData.rentType = v.rentType;
          this.formData.signerName = v.personName;
          this.formData.signerPhone = v.phone;
          if (v.enterpriseName) {
            this.formData.leaseName = v.enterpriseName
          } else {
            this.formData.leaseName = v.personName
          }
          this.roomChooseData = {
            roomChooseCodes: [],
            roomInfoList: [],
            bedChooseCodes: [],
            bedsList: [],
            roomList: deepClone(this.roomList)
          }
          this.leaseArea = ''
          this.roomUsage = ''
          this.roomUnitPrice = ''
          if (this.formData.rentType == 1) {
            this.contractManagerLeaseItems.map(item => {
              item.leaseContractPerUnit = '3'
            })
            this.contractManagerPropertyItems.map(item => {
              item.propertyContractPerUnit = '3'
            })
          } else {
            this.contractManagerLeaseItems.map(item => {
              item.leaseContractPerUnit = '1'
            })
            this.contractManagerPropertyItems.map(item => {
              item.propertyContractPerUnit = '1'
            })
          }
        }
      })
      this.roomListRemoteMethod()
    },

    // 获取房间列表
    roomListRemoteMethod(query) {
      this.$axios.post(api.getRoomInfoList, {
        rentType: this.formData.rentType,
        searchKey: query || '',
      })
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v._label = `${v.buildingName}/${v.floorName}层/${v.roomNumber}`
          })
          this.roomList = data;
          this.roomChooseData.roomList = deepClone(this.roomList)
        })
        .catch(errorHandler("获取房间列表失败"));
    },

    // 选择房间
    changeRoomChoose (codes) {
      let roomInfoList = []
      let allBeds = []
      this.roomChooseData.roomList.map(v => {
        if (codes.indexOf(v.code) !== -1) {
          roomInfoList.push(deepClone(v))
          if (v.beds) {
            allBeds = allBeds.concat(deepClone(v.beds))
          }
        }
      })
      this.roomChooseData.roomInfoList = roomInfoList
      this.roomChooseData.bedChooseCodes = []
      this.roomChooseData.bedsList = allBeds

      // 计算租赁面积、房屋用途、房间单价
      if (roomInfoList.length > 0) {
        // 租赁面积：所选房间面积的总和
        let totalArea = 0
        roomInfoList.forEach(v => {
          totalArea += parseFloat(v.roomArea || 0)
        })
        this.leaseArea = totalArea.toFixed(2)

        // 房屋用途：取房间type字段，通过typeList映射为文字，去重后用顿号连接
        let usageSet = new Set()
        roomInfoList.forEach(v => {
          if (v.type) {
            let typeItem = this.typeList.find(item => item.code === v.type)
            if (typeItem) {
              usageSet.add(typeItem.name)
            }
          }
        })
        this.roomUsage = [...usageSet].join('、')

        // 房间单价：所选房间价格的平均值，元/月
        let totalPrice = 0
        let priceCount = 0
        roomInfoList.forEach(v => {
          if (v.rentMoney) {
            totalPrice += parseFloat(v.rentMoney)
            priceCount++
          }
        })
        if (priceCount > 0) {
          this.roomUnitPrice = (totalPrice / priceCount).toFixed(2)
        } else {
          this.roomUnitPrice = ''
        }
        // 自动回填合同单价（租金和物业费第一段）
        if (this.roomUnitPrice) {
          this.contractManagerLeaseItems[0].leaseContractPer = this.roomUnitPrice
          this.contractManagerPropertyItems[0].propertyContractPer = this.roomUnitPrice
        }
      } else {
        this.leaseArea = ''
        this.roomUsage = ''
        this.roomUnitPrice = ''
      }
    },

    // 选择床位
    changeBedsChoose (codes) {
      let bedsList = []
      this.roomChooseData.bedsList.map(v => {
        if (codes.indexOf(v.code) !== -1) {
          bedsList.push(v)
        }
      })
      this.roomChooseData.roomInfoList.map(roomInfo => {
        roomInfo.beds = deepClone(bedsList)
      })
    },


    // 上传成功
    uploadContractSuccess (res) {
      let fileUrl = res.data
      this.formData.attachmentList.push(fileUrl)
      this.$refs.uploadContract.clearFiles()
    },
    // 上传失败
    uploadContractError (err) {
      nError('上传失败')
    },
    // 删除pdf
    deleteAttachmentItem (index) {
      this.formData.attachmentList.splice(index, 1)
    },
    previewFile (url) {
      if (url.indexOf('.doc') === -1) {
        window.open(url, '_blank')
      } else {
        window.open('http://view.officeapps.live.com/op/view.aspx?src=' + url, '_blank')
      }
    },
    toCustomManagement() {
      this.$router.push({
        name: "contract-management"
      });
    },



    remoteMethod(query) {
      this.getYqPersonList(query);
    },

    // 获取跟进人列表
    getYqPersonList(searchKey) {
      this.$axios
        .post(api.getYqPersonList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.yqPersonList = data;
          }
        })
        .catch(errorHandler("获取跟进人列表失败"));
    },

    leasePledgeChange() {
      if (this.formData.leasePledge) {
        this.formData.leasePledge = parseFloat(
          this.formData.leasePledge
        ).toFixed(2);
      } else {
        this.formData.leasePledge = "0.00";
      }
    },

    propertyPledgeChange() {
      if (this.formData.propertyPledge) {
        this.formData.propertyPledge = parseFloat(
          this.formData.propertyPledge
        ).toFixed(2);
      } else {
        this.formData.propertyPledge = "0.00";
      }
    },

    otherItemValueChange(index) {
      if (this.formData.others[index].otherItemValue) {
        this.formData.others[index].otherItemValue = parseFloat(this.formData.others[index].otherItemValue).toFixed(2);
      } else {
        this.formData.others[index].otherItemValue = "0.00";
      }
    },

    changePickerOptions1() {
      let contractStartDateTime =
        new Date(this.formData.contractStartDate).getTime() - 3600 * 24 * 1000;
      this.pickerOptions1 = {
        disabledDate(time) {
          return time.getTime() < contractStartDateTime;
        }
      };
    },

    changePickerOptions2() {
      let contractEndDateTime = new Date(
        this.formData.contractEndDate
      ).getTime();
      this.pickerOptions2 = {
        disabledDate(time) {
          return time.getTime() > contractEndDateTime;
        }
      };
    },

    changeContractStartDate() {
      this.changePickerOptions1();
      this.formData.leaseContractStartDate = this.formData.contractStartDate;
      this.formData.propertyContractStartDate = this.formData.contractStartDate;
      this.dateDifference();
      this.propertyDateDifference();
    },

    changeContractEndDate() {
      this.changePickerOptions2();
      this.formData.leaseContractEndDate = this.formData.contractEndDate;
      this.formData.propertyContractEndDate = this.formData.contractEndDate;
      this.dateDifference();
      this.propertyDateDifference();
    },

    dateDifference() {
      let dateSpan, iDays;
      let sDate1 = Date.parse(this.formData.leaseContractStartDate);
      let sDate2 = Date.parse(this.formData.leaseContractEndDate);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      let years = iDays / 365;
      this.incrementalTimePointList = [];
      for (let i = 1; i < years; i++) {
        let leaseContractStartDate = this.formData.leaseContractStartDate;
        let leaseContractStartDateArr = leaseContractStartDate.split("-");
        leaseContractStartDateArr[0] =
          parseInt(leaseContractStartDateArr[0]) + i;
        let code = leaseContractStartDateArr.join("-");
        let obj = {
          code: code,
          value: `计租 ${i} 年`
        };
        this.incrementalTimePointList.push(obj);
        // let dateTime = new Date(this.formData.leaseContractStartDate)
        // let dateTime1 = dateTime.getTime() + 365 * 24 * 3600 * 1000 * i
        // let timestamp = new Date(dateTime1)
        // let y = timestamp.getFullYear();
        // let m = (timestamp.getMonth() + 1) < 10 ? "0" + (timestamp.getMonth()+1) : (timestamp.getMonth()+1)
        // let d = timestamp.getDate() < 10 ? "0" + timestamp.getDate() : timestamp.getDate()
      }
    },

    // 增加租金分段
    addContractManagerLeaseItem() {
      let obj = {
        leaseContractStartDate: "", // 租金开始日期
        leaseContractEndDate: "", // 租金结束日期
        leaseContractPer: "", // 合同单价
        leaseContractPerUnit: "1", // 合同单价单位
        leaseAheadPayDays: "", // 提前付款天数
        leaseRentDivideType: "1", // 租期划分方式
        leasePerDayType: "1", // 天单价换算规则
        leasePayUnitType: "2", // 计费类型
        daysInYear: 365, // 年天数
        leasePayPeriod: "1" // 付款周期
      };
      this.contractManagerLeaseItems.push(obj);
    },

    // 删除租金分段
    removeContractManagerLeaseItem(index) {
      this.contractManagerLeaseItems.splice(index, 1);
    },

    // 增加物业费分段
    addContractManagerPropertyItem() {
      let obj = {
        propertyContractStartDate: "", // 合同开始日期
        propertyContractEndDate: "", // 合同结束日期
        propertyContractPer: "", // 合同单价
        propertyContractPerUnit: "2", // 合同单价单位
        propertyPerDayType: "1", // 天单价换算规则
        propertyAheadPayDays: 15, // 提前付款天数
        propertyRentDivideType: "1", // 租期划分方式
        propertyPayUnitType: "2", // 计费类型
        daysInYear: 365, // 年天数
        propertyPayPeriod: "1" // 付款周期
      };
      this.contractManagerPropertyItems.push(obj);
    },

    // 删除租金分段
    removeContractManagerPropertyItem(index) {
      this.contractManagerPropertyItems.splice(index, 1);
    },

    // 增加递增率行
    addLeaseLine() {
      if (this.contractManagerIncreaseLeases.length < this.incrementalTimePointList.length) {
        let obj = {
          leaseIncreaseTimePoint: "",
          leaseIncreasePriceRate: ""
        };
        this.contractManagerIncreaseLeases.push(obj);
      } else {
        nError("超过合同年限，无需再加");
      }
    },

    // 删除递增率行
    removeLeaseLine(index) {
      this.contractManagerIncreaseLeases.splice(index, 1);
    },

    propertyDateDifference() {
      let dateSpan, iDays;
      let sDate1 = Date.parse(this.formData.propertyContractStartDate);
      let sDate2 = Date.parse(this.formData.propertyContractEndDate);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      let years = iDays / 365;
      this.propertyIncrementalTimePointList = [];
      for (let i = 1; i < years; i++) {
        let propertyContractStartDate = this.formData.propertyContractStartDate;
        let propertyContractStartDateArr = propertyContractStartDate.split("-");
        propertyContractStartDateArr[0] =
          parseInt(propertyContractStartDateArr[0]) + i;
        let code = propertyContractStartDateArr.join("-");
        let obj = {
          code: code,
          value: `计租 ${i} 年`
        };
        this.propertyIncrementalTimePointList.push(obj);
        // let dateTime = new Date(this.formData.propertyContractStartDate)
        // let dateTime1 = dateTime.getTime() + 365 * 24 * 3600 * 1000 * i
        // let timestamp = new Date(dateTime1)
        // let y = timestamp.getFullYear();
        // let m = (timestamp.getMonth() + 1) < 10 ? "0" + (timestamp.getMonth()+1) : (timestamp.getMonth()+1)
        // let d = timestamp.getDate() < 10 ? "0" + timestamp.getDate() : timestamp.getDate()
      }
    },

    // 增加物业递增率行
    addPropertyLine() {
      if (
        this.contractManagerIncreaseProperties.length <
        this.incrementalTimePointList.length
      ) {
        let obj = {
          propertyIncreaseTimePoint: "",
          propertyIncreasePriceRate: ""
        };
        this.contractManagerIncreaseProperties.push(obj);
      } else {
        nError("超过合同年限，无需再加");
      }
    },

    // 删除物业递增率行
    removePropertyLine(index) {
      this.contractManagerIncreaseProperties.splice(index, 1);
    },

    // 增加租金优惠
    addContractManagerDiscountLeases() {
      let obj = {
        discountType: "1",
        startTime: "",
        endTime: "",
        memo: "",
        timeArr: ""
      };
      this.contractManagerDiscountLeases.push(obj);
    },

    // 删减租金优惠
    removeContractManagerDiscountLeases(index) {
      this.contractManagerDiscountLeases.splice(index, 1);
    },

    // 增加物业优惠
    addContractManagerDiscountProperties() {
      let obj = {
        discountType: "1",
        startTime: "",
        endTime: "",
        memo: "",
        timeArr: ""
      };
      this.contractManagerDiscountProperties.push(obj);
    },

    // 删减物业优惠
    removeContractManagerDiscountProperties(index) {
      this.contractManagerDiscountProperties.splice(index, 1);
    },

    // 增加其他费用
    addOtherItemLine() {
      let obj = {
        otherItemName: "",
        otherItemValue: "",
        otherItemType: '0',
        payPeriod: '1'
      };
      this.formData.others.push(obj);
    },

    // 删减其他费用
    removeOtherItemLine(index) {
      this.formData.others.splice(index, 1);
    },

    changeLeaseContractPer(index) {
      if (this.contractManagerLeaseItems[index].leaseContractPer) {
        this.contractManagerLeaseItems[index].leaseContractPer = parseFloat(
          this.contractManagerLeaseItems[index].leaseContractPer
        ).toFixed(2);
      } else {
        this.contractManagerLeaseItems[index].leaseContractPer = "0.00";
      }
      this.calculationBond();
    },
    changePropertyContractPer(index) {
      if (this.contractManagerPropertyItems[index].propertyContractPer) {
        this.contractManagerPropertyItems[
          index
        ].propertyContractPer = parseFloat(
          this.contractManagerPropertyItems[index].propertyContractPer
        ).toFixed(2);
      } else {
        this.contractManagerPropertyItems[index].propertyContractPer = "0.00";
      }
    },

    // 租金递增率
    changeContractManagerIncreaseLeasesPer(index) {
      if (this.contractManagerIncreaseLeases[index].leaseIncreasePriceRate) {
        this.contractManagerIncreaseLeases[
          index
        ].leaseIncreasePriceRate = parseFloat(
          this.contractManagerIncreaseLeases[index].leaseIncreasePriceRate
        ).toFixed(2);
      } else {
        this.contractManagerIncreaseLeases[index].leaseIncreasePriceRate = "";
      }
    },

    // 物业递增率
    changeContractManagerIncreasePropertiesPer(index) {
      if (
        this.contractManagerIncreaseProperties[index].propertyIncreasePriceRate
      ) {
        this.contractManagerIncreaseProperties[
          index
        ].propertyIncreasePriceRate = parseFloat(
          this.contractManagerIncreaseProperties[index]
            .propertyIncreasePriceRate
        ).toFixed(2);
      } else {
        this.contractManagerIncreaseProperties[
          index
        ].propertyIncreasePriceRate = "";
      }
    },

    // 生成租金明细
    getRentDetail() {
      let contractManagerDiscountLeases = [];
      this.contractManagerDiscountLeases.map(v => {
        if (v.startTime && v.endTime) {
          contractManagerDiscountLeases.push(v);
        }
      });
      let contractManagerLeaseItems = [], roomList = []
      this.contractManagerLeaseItems.map(v => {
        if (v.leaseContractStartDate && v.leaseContractEndDate && v.leaseContractPer && v.leaseAheadPayDays) {
          contractManagerLeaseItems.push(v);
        }
      });
      this.roomChooseData.roomInfoList.map(v => {
        if (v.code) {
          roomList.push(v)
        }
      })
      this.formData.contractManagerDiscountLeases = contractManagerDiscountLeases;
      this.formData.contractManagerLeaseItems = contractManagerLeaseItems;
      this.formData.roomList = roomList
      this.formData.leaseArea = this.leaseArea
      this.formData.roomUsage = this.roomUsage
      this.formData.roomUnitPrice = this.roomUnitPrice
      if (!this.formData.leaseCode) {
        nError("请选择承租主体");
        return false;
      }
      if (this.formData.roomList.length === 0) {
        nError("请选择房源信息");
        return false;
      }
      if (this.formData.contractManagerLeaseItems.length === 0) {
        nError("请输入完整信息");
        return false;
      }
      this.formData.contractManagerIncreaseLeases = [];
      this.contractManagerIncreaseLeases.map(v => {
        if (v.leaseIncreaseTimePoint && v.leaseIncreasePriceRate) {
          this.formData.contractManagerIncreaseLeases.push(v);
        }
      });
      this.$axios.post(api.getRentDetail, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let total = 0;
            data.detailList.map(v => {
              if (!v.children) {
                v.children = [];
              }
              if (this.formData.leaseContractPerUnit === '1') {
                v.contractPerText = "元 / 间 / 月"
              } else if (this.formData.leaseContractPerUnit === "2") {
                v.contractPerText = "元 / 间 / 天"
              } else if (this.formData.leaseContractPerUnit === "3") {
                v.contractPerText = "元 / 床 / 月"
              } else if (this.formData.leaseContractPerUnit === "4") {
                v.contractPerText = "元 / 床 / 天"
              }
              total = total + parseFloat(v.mustReceive);
            });
            this.rentTotal1 = total.toFixed(2);
            this.rentTotal2 = total.toFixed(2);
            this.rentTotal1_1 = parseFloat(data.deposit.mustReceive);
            this.rentTotal2_1 = parseFloat(data.deposit.mustReceive);
            this.rentDetailData = true;
            this.rentDetail = data;
            this.rentDefaultDetail = data;
          }
        })
        .catch(errorHandler("生成租金明细失败"));
    },

    // 生成物业明细
    getPropertyDetail() {
      let contractManagerDiscountProperties = [];
      this.contractManagerDiscountProperties.map(v => {
        if (v.startTime && v.endTime) {
          contractManagerDiscountProperties.push(v);
        }
      });
      let contractManagerPropertyItems = [], roomList = []
      this.contractManagerPropertyItems.map(v => {
        if (v.propertyContractStartDate && v.propertyContractEndDate && v.propertyContractPer && v.propertyAheadPayDays) {
          contractManagerPropertyItems.push(v);
        }
      });
      this.roomChooseData.roomInfoList.map(v => {
        if (v.code) {
          roomList.push(v)
        }
      })
      this.formData.contractManagerPropertyItems = contractManagerPropertyItems;
      this.formData.contractManagerDiscountProperties = contractManagerDiscountProperties;
      this.formData.roomList = roomList
      this.formData.leaseArea = this.leaseArea
      this.formData.roomUsage = this.roomUsage
      this.formData.roomUnitPrice = this.roomUnitPrice
      if (!this.formData.leaseCode) {
        nError("请选择承租主体");
        return false;
      }
      if (this.formData.roomList.length === 0) {
        nError("请选择房源信息");
        return false;
      }
      if (this.formData.contractManagerPropertyItems === 0) {
        nError("请输入完整信息");
        return false;
      }
      this.formData.contractManagerIncreaseProperties = [];
      this.contractManagerIncreaseProperties.map(v => {
        if (v.propertyIncreaseTimePoint && v.propertyIncreasePriceRate) {
          this.formData.contractManagerIncreaseProperties.push(v);
        }
      });
      this.$axios.post(api.getPropertyDetail, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let total = 0;
            data.detailList.map(v => {
              if (!v.children) {
                v.children = [];
              }
              if (this.formData.propertyContractPerUnit === "1") {
                v.contractPerText = "元 / 间 / 月"
              } else if (this.formData.propertyContractPerUnit === "2") {
                v.contractPerText = "元 / 间 / 天"
              } else if (this.formData.propertyContractPerUnit === "3") {
                v.contractPerText = "元 / 床 / 月"
              } else if (this.formData.propertyContractPerUnit === "4") {
                v.contractPerText = "元 / 床 / 天"
              }
              total = total + parseFloat(v.mustReceive);
            });
            // if (data.deposit.mustReceive) {
            //   total = total + parseFloat(data.deposit.mustReceive)
            // }
            this.propertyTotal1_1 = parseFloat(data.deposit.mustReceive) || 0;
            this.propertyTotal2_1 = parseFloat(data.deposit.mustReceive) || 0;
            this.propertyTotal1 = total.toFixed(2);
            this.propertyTotal2 = total.toFixed(2);
            this.propertyDetailData = true;
            this.propertyDetail = data;
            this.propertyDefaultDetail = data;
          }
        })
        .catch(errorHandler("生成物业明细失败"));
    },

    // 租金明细一键取整
    roundingRent() {
      this.rentDetail.detailList.map(v => {
        if (v.children) {
          v.children.map(children => {
            children.actualReceive = parseFloat(children.actualReceive).toFixed(
              0
            );
          });
        }
        v.actualReceive = parseFloat(v.actualReceive).toFixed(0);
      });
    },

    // 修改租金明细
    confirmChangeRent() {
      this.changeRentData = false;
      this.rentTotal2 = 0;
      this.rentDetail.detailList.map(v => {
        if (v.children.length > 0) {
          let actualReceive = 0;
          v.children.map(child => {
            actualReceive = actualReceive + parseFloat(child.actualReceive);
          });
          v.actualReceive = actualReceive;
          this.rentTotal2 = this.rentTotal2 + actualReceive;
        } else {
          this.rentTotal2 = this.rentTotal2 + parseFloat(v.actualReceive);
        }
      });
      if (this.rentDetail.deposit.actualReceive) {
        this.rentTotal2_1 = parseFloat(this.rentDetail.deposit.actualReceive);
      }
      this.rentTotal2 = this.rentTotal2.toFixed(2);
      this.rentTotal2_1 = this.rentTotal2_1.toFixed(2);
      this.rentNumberToFixed2();
      this.rentDefaultDetail = this.rentDetail;
    },

    cancelChangeRent() {
      this.changeRentData = false;
      this.rentDetail = this.rentDefaultDetail;
    },

    // 物业明细一键取整
    roundingProperty() {
      this.propertyDetail.detailList.map(v => {
        if (v.children) {
          v.children.map(children => {
            children.actualReceive = parseFloat(children.actualReceive).toFixed(
              0
            );
          });
        }
        v.actualReceive = parseFloat(v.actualReceive).toFixed(0);
      });
    },

    confirmChangeProperty() {
      this.changePropertyData = false;
      this.propertyTotal2 = 0;
      this.propertyDetail.detailList.map(v => {
        if (v.children.length > 0) {
          let actualReceive = 0;
          v.children.map(child => {
            actualReceive = actualReceive + parseFloat(child.actualReceive);
          });
          v.actualReceive = actualReceive;
          this.propertyTotal2 = this.propertyTotal2 + actualReceive;
        } else {
          this.propertyTotal2 =
            this.propertyTotal2 + parseFloat(v.actualReceive);
        }
      });
      if (this.propertyDetail.deposit.actualReceive) {
        this.propertyTotal2_1 = parseFloat(
          this.propertyDetail.deposit.actualReceive
        );
      }
      this.propertyTotal2 = this.propertyTotal2.toFixed(2);
      this.propertyTotal2_1 = this.propertyTotal2_1.toFixed(2);
      this.propertyNumberToFixed2();
      this.propertyDefaultDetail = this.propertyDetail;
    },

    cancelChangeProperty() {
      this.changePropertyData = false;
      this.propertyDetail = this.propertyDefaultDetail;
    },

    rentNumberToFixed2() {
      if (this.rentDetail.deposit.actualReceive) {
        this.rentDetail.deposit.actualReceive = parseFloat(
          this.rentDetail.deposit.actualReceive
        ).toFixed(2);
      }
      this.rentDetail.detailList.map(v => {
        if (v.actualReceive) {
          v.actualReceive = parseFloat(v.actualReceive).toFixed(2);
        } else {
          v.actualReceive = "0.00";
        }
      });
    },

    propertyNumberToFixed2() {
      if (this.propertyDetail.deposit.actualReceive) {
        this.propertyDetail.deposit.actualReceive = parseFloat(
          this.propertyDetail.deposit.actualReceive
        ).toFixed(2);
      }
      this.propertyDetail.detailList.map(v => {
        if (v.actualReceive) {
          v.actualReceive = parseFloat(v.actualReceive).toFixed(2);
        } else {
          v.actualReceive = "0.00";
        }
      });
    },

    modifiedSubsetUnitPrice(item) {
      let actualReceive = 0;
      item.children.map(v => {
        actualReceive = actualReceive + parseFloat(v.actualReceive);
        v.actualReceive = parseFloat(v.actualReceive).toFixed(2);
      });
      actualReceive = actualReceive.toFixed(2);
      item.actualReceive = actualReceive;
    },

    // 获取审批人员列表
    getAccountListByCode() {
      this.$axios.post(api.getAccountListByCode, {
          accountCode: this.accountCode
        })
        .then(res => {
          let data = res.data.data;
          if (data.length > 0) {
            data.map(v => {
              v._labelName = `${v.name} / ${v.actualName}`;
            });
          }
          this.accountList = data;
        })
        .catch(errorHandler("获取审批人员列表失败"));
    },

    // 表单校验
    validateForm() {
      if (!this.formData.leaseCode) {
        nError("请选择承租主体");
        return false;
      }
      if (this.formData.roomList.length === 0) {
        nError("请选择房源信息");
        return false;
      }
      if (!this.formData.signerName) {
        nError("请选择签订人姓名");
        return false;
      }
      if (!this.formData.code) {
        nError("请输入合同编号");
        return false;
      }
      if (!this.formData.contractStartDate) {
        nError("请选择合同开始时间");
        return false;
      }
      if (!this.formData.contractEndDate) {
        nError("请选择合同结束时间");
        return false;
      }
      if (!this.formData.contractSignDate) {
        nError("请选择合同签订时间");
        return false;
      }
      // 租金条款校验
      for (let i = 0; i < this.contractManagerLeaseItems.length; i++) {
        const item = this.contractManagerLeaseItems[i];
        const prefix = this.contractManagerLeaseItems.length > 1 ? `租金条款第${i + 1}段：` : "";
        if (!item.leaseContractStartDate) {
          nError(`${prefix}请选择租金开始时间`);
          return false;
        }
        if (!item.leaseContractEndDate) {
          nError(`${prefix}请选择租金结束时间`);
          return false;
        }
        if (!item.leaseContractPer) {
          nError(`${prefix}请输入合同单价`);
          return false;
        }
        if (!item.leaseAheadPayDays && item.leaseAheadPayDays !== 0) {
          nError(`${prefix}请输入提前付款天数`);
          return false;
        }
        if ((item.leaseContractPerUnit === '2' || item.leaseContractPerUnit === '4') && !item.leasePerDayType) {
          nError(`${prefix}请选择天单价换算`);
          return false;
        }
        if (
          ((item.leaseContractPerUnit === '1' && item.leasePayUnitType === '2') ||
           (item.leaseContractPerUnit === '4' && item.leasePayUnitType === '2') ||
           (item.leaseContractPerUnit === '2' && item.leasePerDayType === '2') ||
           (item.leaseContractPerUnit === '3' && item.leasePerDayType === '2')) &&
          !item.daysInYear
        ) {
          nError(`${prefix}请选择年天数`);
          return false;
        }
        if (!item.leasePayPeriod) {
          nError(`${prefix}请选择付款周期`);
          return false;
        }
      }
      // 物业费条款校验
      for (let i = 0; i < this.contractManagerPropertyItems.length; i++) {
        const item = this.contractManagerPropertyItems[i];
        const prefix = this.contractManagerPropertyItems.length > 1 ? `物业费条款第${i + 1}段：` : "";
        if (!item.propertyContractStartDate) {
          nError(`${prefix}请选择物业开始时间`);
          return false;
        }
        if (!item.propertyContractEndDate) {
          nError(`${prefix}请选择物业结束时间`);
          return false;
        }
        if (!item.propertyContractPer) {
          nError(`${prefix}请输入物业合同单价`);
          return false;
        }
        if (!item.propertyAheadPayDays && item.propertyAheadPayDays !== 0) {
          nError(`${prefix}请输入物业提前付款天数`);
          return false;
        }
        if ((item.propertyContractPerUnit === '2' || item.propertyContractPerUnit === '3') && !item.propertyPerDayType) {
          nError(`${prefix}请选择天单价换算`);
          return false;
        }
        if (
          ((item.propertyContractPerUnit === '1' && item.propertyPayUnitType === '2') ||
           (item.propertyContractPerUnit === '4' && item.propertyPayUnitType === '2') ||
           (item.propertyContractPerUnit === '2' && item.propertyPerDayType === '2') ||
           (item.propertyContractPerUnit === '3' && item.propertyPerDayType === '2')) &&
          !item.daysInYear
        ) {
          nError(`${prefix}请选择年天数`);
          return false;
        }
        if (!item.propertyPayPeriod) {
          nError(`${prefix}请选择付款周期`);
          return false;
        }
      }
      if (!this.rentDefaultDetail.detailList) {
        nError("请先生成租金明细");
        return false;
      }
      if (!this.formData.fellowPeopleCode) {
        nError("请选择合同跟进人");
        return false;
      }
      if (this.propertyTotal1 !== this.propertyTotal2 && !this.formData.memo) {
        nError("请输入金额修订说明");
        return false;
      }
      return true;
    },

    // 保存合同
    confirm() {
      let roomList = []
      this.roomChooseData.roomInfoList.map(v => {
        if (v.code) {
          roomList.push(v)
        }
      })
      this.formData.roomList = roomList
      this.formData.leaseArea = this.leaseArea
      this.formData.roomUsage = this.roomUsage
      this.formData.roomUnitPrice = this.roomUnitPrice
      if (!this.validateForm()) return;

      if (this.changeRentData) {
        this.formData.leaseContractManagerDetails = this.rentDefaultDetail.detailList;
        this.formData.leaseContractManagerDetail = this.rentDefaultDetail.deposit;
      } else {
        this.formData.leaseContractManagerDetails = this.rentDetail.detailList;
        this.formData.leaseContractManagerDetail = this.rentDetail.deposit;
      }
      if (this.changePropertyData) {
        this.formData.propertyContractManagerDetails = this.propertyDefaultDetail.detailList;
        this.formData.propertyContractManagerDetail = this.propertyDefaultDetail.deposit;
      } else {
        this.formData.propertyContractManagerDetails = this.propertyDetail.detailList;
        this.formData.propertyContractManagerDetail = this.propertyDetail.deposit;
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name;
        }
      });
      this.$axios.post(api.saveContract, this.formData)
        .then(res => {
          nSuccess("保存成功");
          this.toCustomManagement();
        })
        .catch(errorHandler("保存失败"));
    },
    confirmAndApproval() {
      let roomList = []
      this.roomChooseData.roomInfoList.map(v => {
        if (v.code) {
          roomList.push(v)
        }
      })
      this.formData.roomList = roomList
      this.formData.leaseArea = this.leaseArea
      this.formData.roomUsage = this.roomUsage
      this.formData.roomUnitPrice = this.roomUnitPrice
      if (!this.validateForm()) return;

      if (this.changeRentData) {
        this.formData.leaseContractManagerDetails = this.rentDefaultDetail.detailList;
        this.formData.leaseContractManagerDetail = this.rentDefaultDetail.deposit;
      } else {
        this.formData.leaseContractManagerDetails = this.rentDetail.detailList;
        this.formData.leaseContractManagerDetail = this.rentDetail.deposit;
      }
      if (this.changePropertyData) {
        this.formData.propertyContractManagerDetails = this.propertyDefaultDetail.detailList;
        this.formData.propertyContractManagerDetail = this.propertyDefaultDetail.deposit;
      } else {
        this.formData.propertyContractManagerDetails = this.propertyDetail.detailList;
        this.formData.propertyContractManagerDetail = this.propertyDetail.deposit;
      }
      this.yqPersonList.map(v => {
        if (v.code === this.formData.fellowPeopleCode) {
          this.formData.fellowPeopleName = v.name;
        }
      });
      this.formData.roomInfoSeat = this.formData.officeSeat;
      this.$axios
        .post(api.saveContract, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            let contractCode = res.data.data;
            if (contractCode) {
              this.contractCode = contractCode;
              this.approveDialog = true;
              nSuccess("保存成功");
              // this.$confirm('保存合同成功，是否提交审批？', '提示', {
              //   type: 'info'
              // })
              //   .then(() => {
              //     this.$axios.post(api.passContract, {
              //       code: contractCode
              //     })
              //       .then(res => {
              //         if (res.data.retCode === 1) {
              //           nSuccess('审批通过')
              //           this.toCustomManagement()
              //         }
              //       })
              //       .catch(errorHandler('审批失败'))
              //   })
              //   .catch(() => {
              //     this.toCustomManagement()
              //   })
            }
          }
        })
        .catch(errorHandler("保存失败"));
    },
    cancel() {
      this.toCustomManagement();
    },

    // 取消审批
    cancelApprove() {
      this.approveDialog = false;
      this.approveAccountCode = "";
      this.digest = "";
    },

    // 提交审批
    confirmApprove() {
      let obj = {
        contractCode: this.contractCode,
        sponsorAccountCode: this.accountCode,
        sponsorAccountName: this.accountName,
        digest: this.digest,
        approveType: "4",
        contractApproveChainStatuses: []
      };
      this.accountList.map(v => {
        if (v.code === this.approveAccountCode) {
          let approveObj = {
            approveAccountCode: v.code,
            approveAccountName: v.name
          };
          obj.contractApproveChainStatuses.push(approveObj);
        }
      });
      this.$axios
        .post(api.submitAccount, obj)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("提交审批成功");
            this.toCustomManagement();
          }
        })
        .catch(errorHandler("提交审批失败"));
    },

    // 计算保证金
    calculationBond() {
      // 期数 && 单价 && 单价单位 && 面积或者工位
      let zujinquzhi = this.contractManagerLeaseItems[0];
      if (this.leaseDepositPeriodCount && zujinquzhi.leaseContractPer && zujinquzhi.leaseContractPerUnit) {
        let areaOrOfficeSeat = "";
        if (this.isHousingInUnion) {
          areaOrOfficeSeat = this.formData.officeSeat;
        } else {
          areaOrOfficeSeat = this.formData.roomInfoArea;
        }
        if (zujinquzhi.leaseContractPerUnit === "1") {
          let yearsDay = this.contractManagerLeaseItems[0].daysInYear || 365;
          this.formData.leasePledge = parseFloat(
            ((+zujinquzhi.leaseContractPer * +areaOrOfficeSeat * yearsDay) /
              12) *
              +this.leaseDepositPeriodCount
          ).toFixed(0);
        } else if (zujinquzhi.leaseContractPerUnit === "2") {
          this.formData.leasePledge = parseFloat(
            +zujinquzhi.leaseContractPer *
              +areaOrOfficeSeat *
              +this.leaseDepositPeriodCount
          ).toFixed(0);
        } else if (zujinquzhi.leaseContractPerUnit === "3") {
          this.formData.leasePledge = parseFloat(
            +zujinquzhi.leaseContractPer * +this.leaseDepositPeriodCount
          ).toFixed(0);
        } else if (zujinquzhi.leaseContractPerUnit === "4") {
          let yearsDay = this.contractManagerLeaseItems[0].daysInYear || 365;
          this.formData.leasePledge = parseFloat(
            ((+zujinquzhi.leaseContractPer * yearsDay) / 12) *
              +this.leaseDepositPeriodCount
          ).toFixed(0);
        }
      } else {
        this.formData.leasePledge = "0.00";
      }
    },
  },
  watch: {
    leaseDepositPeriod(v) {
      this.leaseDepositPeriodCount = +v;
      this.calculationBond();
    },

    "formData.officeSeat": {
      handler(newName, oldName) {
        this.calculationBond();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  padding-left: 5px;
  margin-top: 5px;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 5px 0;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  width: 33%;
  margin-right: 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 160px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  margin: 30px auto;
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="less">
// .contractAdd {
//   .el-input--mini {
//     .el-input__inner {
//       height: 32px;
//       line-height: 32px;
//     }
//   }
// }

.el-select .el-input .el-select__caret {
  height: 32px;
}
.el-input-group__append {
  padding: 0 5px !important;
  width: auto !important;
}
.el-input-group__prepend {
  padding: 0 5px !important;
  width: auto !important;
}
.discount-line {
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 20px !important;
  }
}

//.el-tabs__content {
//  .textBox {
//    width: 120px;
//  }
//}

.el-collapse-item__arrow {
  line-height: 48px !important;
}

.contractAdd {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--prefix .el-input__inner {
    padding: 0 0 0 30px;
  }
}

.approveDialogBox {
  text-align: left;
  .el-dialog {
    width: 800px;
  }
  .approveMainBox {
    text-align: center;
  }
  .approve_title {
    width: 120px;
  }
  .approveFlexBox {
    width: 500px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: flex-start;
  }
}

.rent-active {
  .el-range-editor--small {
    .el-range-separator {
      line-height: 30px;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/ContractManagement/ContractAdd.vue